module.exports = __webpack_public_path__ + "static/media/image-2.32d6be18.jpg";